import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////////// services ////////////////////
const servicesUrl = "services";
// get all srvices data
export const getServicesDataRequest = (values) =>
  client.get(servicesUrl, values);

// add service
export const addServiceRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.text && formData.append("text", values.text);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  values.subcategory_id &&
    formData.append("subcategory_id", values.subcategory_id);
  !values.main_image.isWeb &&
    formData.append("main_image", values.main_image.url);
  values.video.isChanged && formData.append("video", values.video.url);
  return client.post(`admin/${servicesUrl}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

// update service
export const updateServiceRequest = (values, onUploadProgress) => {
  console.log(values, "toye service");
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.text && formData.append("text", values.text);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  values.subcategory_id &&
    formData.append("subcategory_id", values.subcategory_id);
  values.category && formData.append("category", values.category);
  !values.main_image.isWeb &&
    formData.append("main_image", values.main_image.url);
  values.video.isChanged && formData.append("video", values.video.url);
  return client.post(
    `admin/${servicesUrl}/${values.id}?_method=put`,
    formData,
    {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    }
  );
};

// get service by id
export const getServiceByIdRequest = (values) => {
  return client.get(`${servicesUrl}/${values.id}`);
};
// delete services by id
export const deleteServiceByIdRequest = (id) =>
  client.delete(`admin/${servicesUrl}/${id}`);

/////// Services subcategory ///////
const serviceSubCategoryUrl = "/services_sub_categories";
// get all Services subcategory
export const getServiceSubCategoryRequest = (values) =>
  client.get(`${serviceSubCategoryUrl}?
  skip=${values.skip ?? 0}&limit=${values.limit ?? 10}`);

// get Services subcategory by id
export const getServiceSubcategoryByIdRequest = (values) =>
  client.get(`${serviceSubCategoryUrl}/${values.id}`);

// add Services subcategory
export const addServiceSubCategoryRequest = (values) =>
  client.post(`/admin${serviceSubCategoryUrl}`, values);

// edit Services subcategory
export const editServiceSubCategoryRequest = (values) =>
  client.post(
    `/admin${serviceSubCategoryUrl}/${values.id}?_method=put`,
    values
  );
// delete Services subcategory
export const deleteServiceSubCategoryByIdRequest = (id) =>
  client.delete(`admin${serviceSubCategoryUrl}/${id}`);
